import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { login_failure, login_success, start_login } from '../../constants/actionTypes';
import "./auth.scss"
import logo from "./../../asset/logo.png"
import { LoginContext } from '../../contexts/LoginContext';
import { api } from '../../proxy';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Linelogin from '../../component/Auth/LineLogin';
// import FbLogin from '../../component/Auth/FbLogin';


const Login = () => {
    // const registerSuccess = useLocation() //接我們register navgate過來的res
    const { error, dispatch } = useContext(LoginContext)
    const [showPassword, setShowPassword] = useState(false);
    const [loginData, setLoginData] = useState({
        account: undefined, //設置Api的時候是設置account 所以要注意不要打成username了
        password: undefined//當初這樣設計是因為我們想要讓他就算是輸入username與email都可以登入
    })
    const handleChange = (e: { target: { id: any; value: any; }; }) => {
        setLoginData(prev => ({ ...prev, [e.target.id]: e.target.value }))
    }
    const navigate = useNavigate(); // react router dom /pass to router and the date and  useNavigate
    const handleClick = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        dispatch({
            type: start_login,
            payload: undefined
        })//
        try {
            const res = await api.post("/auth/login", loginData)
            dispatch({ type: login_success, payload: res.data.userDetails })
            navigate("/")
        } catch (error: any) {
            dispatch({ type: login_failure, payload: error.response.data })
        }
    }
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };
    const componentClicked = () => {
        console.log("clicked");
    };

    return (
        <>
            <div className='auth'>
                <div className="container">
                    <div className="wrapper">
                        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                            <img src={logo} />
                        </Link>
                        <hr />
                        <h3>
                            登入會員
                        </h3>
                        <div className="form">
                            <TextField label='信箱或使用者名稱'
                                error={error && error.message !== "" ? true : false}
                                type="text"
                                id="account"
                                fullWidth
                                InputProps={{
                                    inputProps: {
                                        style: { textAlign: "right" },
                                    },
                                }}
                                onChange={handleChange}
                                placeholder='chiioa@gmail.com' variant="outlined"
                                helperText={error?.message === "沒有此使用者" ? error?.message : ""}
                            />
                            <TextField label='密碼'
                                error={error && error.message !== "" ? true : false}
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                fullWidth
                                InputProps={{
                                    inputProps: {
                                        style: { textAlign: "right" },
                                    },
                                    endAdornment:
                                        <InputAdornment position="start">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                }}
                                onChange={handleChange}
                                placeholder='Chiioa123123' variant="outlined"
                                helperText={error?.message === "輸入密碼錯誤" ? error?.message : ""}
                            />

                            <button className="submit" onClick={handleClick} >登入</button>
                            <div className="hint">
                                <a href='https://line.me/R/ti/p/@018hobbh' style={{ textDecoration: "none", color: "inherit" }}>
                                    忘記密碼 聯絡客服
                                </a>
                                <Link to="/register" style={{ textDecoration: "none", color: "inherit" }}>
                                    <span className='word'>註冊</span><span>＆創建一個帳號</span>
                                </Link>
                            </div>
                            {/* < to="/auth/privacy" style={{ textDecoration: "none", color: "inherit" }}>
                                {/* {error && <span style={{color: "red"}}>{error.message}</span>} */}
                        </div>
                        <hr />
                        <div className="otherLogin">
                            {/* <FbLogin /> */}
                            <Linelogin />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Login
